import { memo, useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import { generateClassName } from '../../../../b2b-common/helpers';
import useAUEImages from '../../../hooks/useAUEImages';

const AUE_Impact = memo(({ data, locale = 'es', size = 500, onClick = null, className = null }) => {
    // Example color palette for AUE categories
    const aueColors = {
        1: '#98BF1E',
        2: '#1064A8',
        3: '#0B908C',
        4: '#7E2348',
        5: '#EA8F1E',
        6: '#F3C115',
        7: '#DD699A',
        8: '#947B27',
        9: '#C10F20',
        10: '#8E1375'
    };

    const { aueImages } = useAUEImages(locale);

    const getPieChartData = () => {
        const totalIndicators = data.reduce((sum, item) => sum + item.indicatorUUIDs.length, 0);
        return data.map((item, idx) => ({
            name: `${item.levelN_ItemId}`,
            value: ((item.indicatorUUIDs.length / totalIndicators) * 100).toFixed(2),
            itemStyle: {
                color: aueColors[item.levelN_ItemId],
                borderColor: '#fff',
                borderWidth: 2
            }
        }));
    };

    const options = {
        tooltip: {
            trigger: 'item',
            formatter: '{d}%'
        },
        series: [
            {
                name: 'Indicators',
                type: 'pie',
                radius: ['50%', '85%'],
                center: ['50%', '50%'],
                padAngle: 2,
                itemStyle: {
                    borderRadius: 5
                },
                data: getPieChartData(),
                label: {
                    show: false
                },
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ],
        graphic: {
            elements: [
                {
                    type: 'image',
                    id: 'aueImage',
                    left: 'center',
                    top: 'center',
                    z: 100,
                    style: {
                        image: '',
                        width: size * 0.25,
                        height: size * 0.25,
                        opacity: 0
                    }
                }
            ]
        }
    };

    const onEvents = {
        'mouseover': (params) => {
            if (params.componentType === 'series' && aueImages) {
                // Try to match by categoryName or fallback to index
                const key = Number(params.data.name);
                const aueImage = aueImages[key] || aueImages[params.dataIndex + 1] || '';
                options.graphic.elements[0].style.image = aueImage;
                options.graphic.elements[0].style.opacity = 1;
                chartRef.current.getEchartsInstance().setOption(options);
            }
        },
        'mouseout': () => {
            options.graphic.elements[0].style.opacity = 0;
            chartRef.current.getEchartsInstance().setOption(options);
        },
        'click': (params) => {
            if (onClick && params.componentType === 'series') {
                onClick(params.data.name);
            }
        }
    };

    const chartRef = useRef(null);
    
    return (
        <ReactECharts
            ref={chartRef}
            option={options}
            onEvents={onEvents}
            className={generateClassName('aue-impact-echart','', className)}
            style={{ height: `${size}px`, width: `${size}px` }}
        />
    );
});

AUE_Impact.displayName = 'AUE_Impact';

export default memo(AUE_Impact);
